module.exports = __webpack_public_path__ + "img/square-plus.48201ba2.svg";